export const RECON_SETTINGS_EVENT = 'adp-recon-settings-changed';

export const QUICK_THRESHOLDS = [
  { label: '$0.01', amount: '0.01', percent: '0' },
  { label: '$1', amount: '1', percent: '0' },
  { label: '$5', amount: '5', percent: '0' },
  { label: '1%', amount: '0.01', percent: '1' },
  { label: '5%', amount: '0.01', percent: '5' },
];

const DEFAULTS = {
  payPeriod: '202610',
  toleranceAmount: '0.01',
  tolerancePercent: '0',
  hoursToleranceAmount: '0.01',
};

function read(key, fallback) {
  const v = localStorage.getItem(key);
  return v != null && v !== '' ? v : fallback;
}

export function getReconSettings() {
  return {
    payPeriod: read('reconPayPeriod', DEFAULTS.payPeriod),
    toleranceAmount: read('reconToleranceAmount', DEFAULTS.toleranceAmount),
    tolerancePercent: read('reconTolerancePercent', DEFAULTS.tolerancePercent),
    hoursToleranceAmount: read('reconHoursToleranceAmount', DEFAULTS.hoursToleranceAmount),
  };
}

export function saveReconSettings(patch) {
  if (patch.payPeriod != null) localStorage.setItem('reconPayPeriod', String(patch.payPeriod).trim());
  if (patch.toleranceAmount != null) {
    localStorage.setItem('reconToleranceAmount', String(patch.toleranceAmount));
  }
  if (patch.tolerancePercent != null) {
    localStorage.setItem('reconTolerancePercent', String(patch.tolerancePercent));
  }
  if (patch.hoursToleranceAmount != null) {
    localStorage.setItem('reconHoursToleranceAmount', String(patch.hoursToleranceAmount));
  }
  window.dispatchEvent(new CustomEvent(RECON_SETTINGS_EVENT));
}

export function formatReconSettingsSummary(s = getReconSettings()) {
  const parts = [`period ${s.payPeriod}`, `$±${s.toleranceAmount}`];
  if (Number(s.tolerancePercent) > 0) parts.push(`${s.tolerancePercent}%`);
  parts.push(`hours ±${s.hoursToleranceAmount}`);
  return parts.join(' · ');
}
